// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XiYa","colBig":"styles_colBig__2VpDe","colSmall":"styles_colSmall__1i4Mz"};